"use client"

import {useState} from "react"
import {APP_COOKIE_APP_ORIGIN, APP_COOKIE_PROJECT_ID, APP_COOKIE_REFERRER_USER_ID} from "@/lib/constants";

interface AppParams {
    referrerUserId: string | null
    projectId: string | null
    appOrigin: string | null
}

function getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
        return parts.pop()?.split(";").shift() || null
    }
    return null
}

export function useAppParams(): AppParams {
    const [params] = useState<AppParams>(() => ({
        referrerUserId: getCookie(APP_COOKIE_REFERRER_USER_ID),
        projectId: getCookie(APP_COOKIE_PROJECT_ID),
        appOrigin: getCookie(APP_COOKIE_APP_ORIGIN),
    }))

    return params
}
